import {toast} from 'react-hot-toast'
// eslint-disable-next-line
import { SAVE_TOKEN,REMOVE_USER, LOGIN_USER, LOAD_USERS, LOGIN_USER_ERROR } from "./UserType";


export function loginUser(email, password, navigate, setLoading) {

 
  
    return async function (dispatch) {
      
      
      setLoading(true)

      try {

        const response = await fetch(`https://salama-api.onrender.com/login`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          "email":email,
          "password":password
          })
        });
        if(response.ok){
          
            const data = await response.json();
            dispatch({
              type: SAVE_TOKEN,
              payload: data.data
            })

            navigate("/user")
            toast.success(`${data.message}`); 
            setLoading(false)    
          
        }else if (response.status === 422) {
          const error = await response.json();
              throw new Error(error.message);
        }else {
          throw new Error('Network response was not ok.');
        }
        
      }catch (error){
        console.error(error.message)
        setLoading(false)
        toast.error(error.message)
      }
      
    };

}

export const saveUser = (data)=>{
  console.log(data)
    return{
        type: LOGIN_USER,
        payload: data
    }
}

export const saveToken = (token)=>{
  console.log(token)
    return{
        type: SAVE_TOKEN,
        payload: token
    }
}

export const logoutUser = (()=>{
  return{
      type: REMOVE_USER
  }
})